// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal__2gFpM","spinner":"spinner__33QZc","spin":"spin__3IY54"};